import AppBar from '@ahamove/web-components/lib/AppBar';
import MuiContainer from '@ahamove/web-components/lib/Container';
import NavigationBar from '@ahamove/web-components/lib/NavigationBar';
import Toolbar from '@ahamove/web-components/lib/Toolbar';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { BANNER_TYPE } from '@/lib/constants';
import type { HomeProps } from '@/pages/index';
import ElevationScroll from '@/shared-components/ElevationScroll';
import Container from '@/shared-components/layouts/Container';
import useIsMobile from '@/shared-hooks/useIsMobile';
import BookingSteps from '../new/booking/BookingSteps';
import EVSelection from '../new/booking/ev/EVSelection';
import { useNewBooking } from '../new/booking/NewBookingProvider';
import FAQContent from './FAQContent';
import { homeConfig } from './homeConfig';
import RentingBenefitContent from './RentingBenefitContent';
import ServicesPriceContent from './ServicesPriceContent';

export default function HomePage({
  helpCenter,
  availableCities,
  homeBannerRes,
}: HomeProps) {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  const { activeStep, backStep, scrollToTop } = useNewBooking();
  const isMobile = useIsMobile();
  const homeBannerData = React.useMemo(
    () =>
      homeBannerRes &&
      homeBannerRes.filter((e) => e.type === BANNER_TYPE.EV_RENTAL),
    [homeBannerRes]
  );

  React.useEffect(() => {
    scrollToTop();
  }, [activeStep]);

  return (
    <Container root header={!(isMobile && activeStep === 1)}>
      {isMobile && activeStep === 1 ? (
        <>
          <ElevationScroll>
            <AppBar color="inherit">
              <NavigationBar
                title={t('home:choose_vehicle').toString()}
                onBack={() => {
                  backStep();
                }}
                sx={{ border: 'none' }}
              />
            </AppBar>
          </ElevationScroll>
          <Toolbar sx={{ minHeight: '48px !important' }} />
        </>
      ) : null}

      <BookingSteps />
      <EVSelection availableCities={availableCities} />
      {activeStep === 0 ? (
        <>
          <MuiContainer
            maxWidth="xl"
            sx={{
              px: isMobile ? 2 : 3,
            }}
            data-test-id="servicesPriceContainer"
          >
            <RentingBenefitContent homeBannerData={homeBannerData} />
            <ServicesPriceContent availableCities={availableCities} />
          </MuiContainer>

          {helpCenter && helpCenter.attributes?.items ? (
            <MuiContainer
              maxWidth="md"
              sx={{
                pt: isMobile ? 8 : 16,
                px: isMobile ? 2 : 3,
                pb: isMobile ? 8 : 15,
                maxWidth: `810px !important`,
              }}
              data-test-id="helpCenterContainer"
            >
              <h2 className="desktop:text-title42 text-title32 desktop:text-center desktop:max-w-full mb-16 max-w-[80%] font-bold text-black">
                {t('home:faq.title')}
              </h2>
              {helpCenter.attributes?.items &&
                helpCenter.attributes?.items.length > 0 && (
                  <FAQContent faq={helpCenter.attributes.items[0]} />
                )}
            </MuiContainer>
          ) : null}
        </>
      ) : null}
    </Container>
  );
}
